import * as React from 'react';
import { HiOutlineExclamation } from 'react-icons/hi';
import { Flex, Icon, Text, Button } from '@chakra-ui/react';
import {
  api,
  clearGlobalData,
  clearUser,
  setPage,
  useAppDispatch,
  useAppSelector,
} from '@spartalabs/pdc-core';
import { logoutPortalSession } from 'utils/logoutPortalSession';

export const NoPortalAccess: React.FC = () => {
  const dispatch = useAppDispatch();
  const { token, refreshToken } = useAppSelector(state => state.authSlicer.user);

  const handleLogout = async () => {
    dispatch(setPage({ page: null }));
    await logoutPortalSession(token, refreshToken);
    dispatch(clearUser());
    dispatch(clearGlobalData());
    dispatch(api.util.resetApiState());
  };

  return (
    <Flex
      h="50vh"
      direction="column"
      alignItems="center"
      justifyContent="center"
      fontSize="xl"
    >
      <Icon
        borderRadius="100px"
        padding="16px"
        bg="grey.200"
        w="96px"
        h="96px"
        as={HiOutlineExclamation}
        color="grey.600"
      />
      <Text fontWeight="medium" color="text.100" fontSize="24px">
        Sem acesso ao portal
      </Text>
      <Text color="text.300" fontSize="16px" textAlign="center" maxW="420px">
        Sua conta não possui permissões para acessar nenhuma área do portal.
        Solicite acesso ao administrador ou entre com outra conta.
      </Text>
      <Button mt="24px" fontSize="14px" variant="outline" onClick={handleLogout}>
        Sair da conta
      </Button>
    </Flex>
  );
};

export default NoPortalAccess;